import axios from 'axios';

const API_URL = 'https://chatpanel.my.id/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  getMe: () => api.get('/auth/me')
};

export const menusAPI = {
  getAll: () => api.get('/menus'),
  getById: (id) => api.get(`/menus/${id}`),
  create: (data) => api.post('/menus', data),
  update: (id, data) => api.put(`/menus/${id}`, data),
  delete: (id) => api.delete(`/menus/${id}`),
  reorder: (items) => api.post('/menus/reorder', { items })
};

export const subMenusAPI = {
  getAll: (menuId) => api.get('/sub-menus', { params: { menu_id: menuId } }),
  getById: (id) => api.get(`/sub-menus/${id}`),
  create: (data) => api.post('/sub-menus', data),
  update: (id, data) => api.put(`/sub-menus/${id}`, data),
  delete: (id) => api.delete(`/sub-menus/${id}`),
  reorder: (items) => api.post('/sub-menus/reorder', { items })
};

export const carouselAPI = {
  getAll: (subMenuId) => api.get('/carousel', { params: { sub_menu_id: subMenuId } }),
  getById: (id) => api.get(`/carousel/${id}`),
  upload: (formData) => api.post('/carousel/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, data) => api.put(`/carousel/${id}`, data),
  delete: (id) => api.delete(`/carousel/${id}`),
  reorder: (items) => api.post('/carousel/reorder', { items })
};

export const settingsAPI = {
  getAll: () => api.get('/settings'),
  update: (key, value) => api.put('/settings', { key, value })
};

export const acronymsAPI = {
  getAll: (activeOnly = false) => api.get('/acronyms', { params: activeOnly ? { active: 1 } : {} }),
  create: (data) => api.post('/acronyms', data),
  update: (id, data) => api.put(`/acronyms/${id}`, data),
  remove: (id, hard = false) => api.delete(`/acronyms/${id}`, { params: hard ? { hard: 1 } : {} })
};

export const liveChatAPI = {
  listConversations: (params = {}) => api.get('/live-chat/conversations', { params }),
  getConversation: (id) => api.get(`/live-chat/conversations/${id}`),
  getMessages: (id, params = {}) => api.get(`/live-chat/conversations/${id}/messages`, { params }),
  claim: (id) => api.put(`/live-chat/conversations/${id}/claim`),
  close: (id) => api.put(`/live-chat/conversations/${id}/close`),
  stats: () => api.get('/live-chat/stats')
};

export default api;
